/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttachmentSubjectDto } from './attachmentSubjectDto.model';
import { AttachmentVariant } from './attachmentVariant.model';
import { AttachmentSource } from './attachmentSource.model';
import { ContractResponseDto } from './contractResponseDto.model';
import { AttachmentUploadedType } from './attachmentUploadedType.model';


export interface AttachmentDto { 
    attachmentSubjects?: Array<AttachmentSubjectDto>;
    barterId?: number;
    budId?: number;
    combined?: boolean;
    contactId?: number;
    contractId?: number;
    contractRelated?: ContractResponseDto;
    dataSize?: number;
    hidden?: boolean;
    id?: number;
    name?: string;
    nonCadastralContractId?: number;
    onlineDocumentLastModified?: string;
    onlineDocumentLink?: string;
    parId?: number;
    signingEligible?: boolean;
    source?: AttachmentSource;
    type?: string;
    updated?: string;
    uploadedType?: AttachmentUploadedType;
    url?: string;
    variant?: AttachmentVariant;
}
export namespace AttachmentDto {
}


